interface SubCategoryTabsProps {
  value: string;
  onChange: (value: string) => void;
}

const tabs = ["全部", "电影", "电视剧", "网络剧", "短片"];

export default function SubCategoryTabs({ value, onChange }: SubCategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          onClick={() => onChange(tab)}
          className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-colors cursor-pointer ${
            value === tab
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}